import { createRouter, createWebHistory } from "vue-router";

// import HomePage from "../pages/HomePage.vue";
import SteamTest from "../pages/SteamTest.vue";
import StreamPage from "../pages/StreamPage.vue";
import ClientVideo from "../pages/ClientVideo.vue";
import NotFound from "../pages/NotFound.vue";
import SubscriptionNotFound from "../pages/SubscriptionNotFound.vue";
import SessionLimitReached from "@/pages/SessionLimitReached.vue";

const routes = [
  // { path: "/", component: HomePage },
  { path: "/:clientId", component: ClientVideo },
  { path: "/not-found", component: NotFound },
  { path: "/sub-not-found", component: SubscriptionNotFound },
  { path: "/session-limit-reached", component: SessionLimitReached },
  { path: "/stream-test", component: SteamTest },
  { path: "/stream", component: StreamPage },
  { path: "/:pathMatch(.*)*", redirect: "/not-found" }, // Catch-all route that redirects to Home
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

export default router;
